import { requester } from "../utils";

export const aboutRsee = () => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/general/about-us`,
                method: "GET",
                withAuth: false,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("get about us error", err);
                reject(err);
            });
    });
};

export const getAllCities = () => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/general/cities`,
                method: "GET",
                withAuth: false,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("get cities error", err);
                reject(err);
            });
    });
};

export const setCityCode = (data) => {
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/general/cities/set-code`,
                method: "POST",
                withAuth: true,
                data,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("set city code error", err);
                reject(err);
            });
    });
};

export const applyInviteCode = (data) =>{
    return new Promise((resolve, reject) => {
        requester
            .fetchAPI({
                route: `v1/general/apply-invite-code`,
                method: "POST",
                withAuth: false,
                data,
            })
            .then((result) => {
                resolve(result.payload);
            })
            .catch((err) => {
                console.log("apply invite code error", err);
                reject(err);
            });
    });
}


export const getAvatars = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/general/user-avatars`,
        method: 'GET',
        withAuth: true,

      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('edit user info error', err);
        reject(err);
      });
  });
};

export const setUserAvatar = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/general/upload-user-avatar`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('edit user info error', err);
        reject(err);
      });
  });
};